import React from 'react';
import { Stack } from 'expo-router';
import { useUnistyles } from 'react-native-unistyles';

/**
 * Public route group layout.
 *
 * Unlike `(tabs)/_layout.jsx`, this group does NOT redirect to auth. Public
 * routes (e.g. `/f/{publicId}`) render for anonymous users. A Supabase session,
 * when present (same-origin web or injected by a native WebView), is read inside
 * the route itself — not gated here.
 */
const PublicLayout = () => {
    const { theme: { colors } } = useUnistyles();

    return (
        <Stack
            screenOptions={{
                headerTransparent: true,
                headerTintColor: colors.text,
                headerTitle: '',
                headerBackTitleVisible: false,
                headerStyle: {
                    height: 100,
                },
            }}
        >
            <Stack.Screen
                name="f/[publicId]"
                options={{
                    headerShown: false,
                }}
            />
            <Stack.Screen name="form-payment" options={{ headerShown: false }} />
            <Stack.Screen
                name="give/[orgHandle]"
                options={{
                    headerShown: false,
                }}
            />
            <Stack.Screen
                name="event-stats/jesus-tent-revival"
                options={{
                    headerShown: false,
                }}
            />
        </Stack>
    );
};

export default PublicLayout;
